import styles from "./RequestResetPassword.module.scss";
import React from "react";
import Form from "react-bootstrap/Form";
import useRequestResetPassword from "./useRequestResetPassword";
import {Link} from "react-router";

const RequestResetPassword = () => {
  const {t, sending, sent, handleReset, error, email, updateEmail} = useRequestResetPassword();

  return <div className={styles.container}>
    <div className={styles.title}>{t("text_ask_email_password_reset_link")}</div>

    {error && <div className={styles.error}>{error}</div>}

    <Form onSubmit={handleReset} className={styles.form}>
      <Form.Group className="mb-2" controlId="request-reset-password-email">
        <Form.Control
          type="text"
          name="request-reset-password-email"
          value={email}
          onChange={updateEmail}
          placeholder={t("placeholder_email")}
          disabled={sending}
        />
      </Form.Group>

      {!sent && <button className={styles.submitBtn} type="submit" disabled={sending}>{t("btn_send_link")}</button>}

      {sent && <div className={styles.sent}>{t("text_link_sent")}</div>}
    </Form>

    <div className={styles.links}>
      <Link to="/signin">{t("link_signin")}</Link>
      <Link to="/signup">{t("link_create_account")}</Link>
    </div>
  </div>;
};

export default RequestResetPassword;
